import { MouseEventHandler, useEffect, useState } from "react";
import ImageCard from "./ImageCard";
import { getCards } from "../utils/Images";
import { Card } from "../utils/types";
import successSound from "../assets/sounds/success.mp3";
import errorSound from "../assets/sounds/wrong.mp3";
import cheerSound from "../assets/sounds/cheer.mp3";
import Header from "./Header";

export default function MemoryGame() {
  const viewDuration = 5000;

  const [cards, setCards] = useState(getCards());
  const [flipped, setFlipped]: [Card[], any] = useState([]);
  const [timeout, setTime]: [NodeJS.Timeout | undefined, any] =
    useState(undefined);

  const updateCards = (
    cardKey: number | string,
    isFlipping: boolean,
    isFinished: boolean = false
  ) => {
    setCards((cards: Card[]) => {
      const cardsCopy = [...cards];
      const targetCard: Card | undefined = cardsCopy.find(
        (c) => c.key === cardKey
      );
      targetCard!.isFlipping = isFlipping;
      targetCard!.isFinished = isFinished;

      if (cards.length === cardsCopy.filter((x: Card) => x.isFinished).length) {
        new Audio(cheerSound).play();
      }
      return cardsCopy;
    });
  };

  const cardClickHandler = (card: Card) => {
    if (
      cards.filter((x: Card) => x.isFlipping && !x.isFinished).length >= 2 ||
      flipped.length >= 2 ||
      card.isFlipping
    )
      return;
    updateCards(card.key, true);
    setFlipped((flippeddata: Card[]) => [...flippeddata, card]);
  };

  useEffect(() => {
    if (flipped.length !== 2) return;
    const [first, second] = flipped;

    if (first && second) {
      setFlipped((flippeddata: Card[]) => []);
      if (first.id === second.id) {
        console.log("Success");
        if (cards.filter((x: Card) => x.isFlipping).length !== cards.length) {
          setTime(
            setTimeout(() => {
              new Audio(successSound).play();
            }, 450)
          );
        }

        updateCards(first.key, true, true);
        updateCards(second.key, true, true);
      } else {
        console.log("Fail");
        setTime(
          setTimeout(() => {
            new Audio(errorSound).play();
            updateCards(first.key, false);
            updateCards(second.key, false);
          }, 900)
        );
      }
    }

    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [flipped]);

  useEffect(() => {
    setTime(
      setTimeout(() => {
        for (let card of cards) {
          updateCards(card.key, false);
        }
      }, viewDuration)
    );
    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, []);

  return (
    <div className="game-container">
      <Header />
      <section className="cards-container">
        {cards.map((card: Card) => (
          <ImageCard
            key={card.key}
            card={card}
            clickHandler={cardClickHandler}
          />
        ))}
      </section>
    </div>
  );
}
